export default function top(px) {
  window.scrollTo({
    top: px,
  });
}
